import { Point } from './point.model';
import { WinReasonEnum } from './csTypes/enums/win_reason';
import { Extension } from './csTypes/extension';

export class Game {
    startDate?: Date;
    gameDuration?: string;
    gameFormat: GameFormat;
    gameNumber: number;
    notes?: string;
    points: Point[] = [];
    side1Score: number = 0;
    side2Score: number = 0;
    timestamp: Date;
    updated?: Date;
    winningSide?: number;
    currentScoringType?: string;
    /**
     * Reason for point win, PENALTY, ACE, WINNER, etc..
     */
    winReason?: WinReasonEnum;
    extensions?: Extension[] = [];
}

export enum GameFormat {
    STANDARD = 'STANDARD',
    TIEBREAK = 'TIEBREAK'
}
